import activityDashed from './activity-dashed.svg';
import activityDoubleDashed from './activity-double-dashed.svg';
import activityDouble from './activity-double.svg';
import activityThick from './activity-thick.svg';
import activity from './activity.svg';
import data from './data.svg';
import datastore from './datastore.svg';
import eventDashed from './event-dashed.svg';
import eventDoubleDashed from './event-double-dashed.svg';
import eventDouble from './event-double.svg';
import eventThick from './event-thick.svg';
import event from './event.svg';
import gateway from './gateway.svg';

const borderIcons = {
  businessProcessEvent: {
    default: event,
    double: eventDouble,
    'double-dashed': eventDoubleDashed,
    thick: eventThick,
    dashed: eventDashed,
  },
  businessProcessActivity: {
    default: activity,
    double: activityDouble,
    'double-dashed': activityDoubleDashed,
    thick: activityThick,
    dashed: activityDashed,
  },
  businessProcessGateway: { default: gateway },
  businessProcessData: { default: data },
  businessProcessDataStore: { default: datastore },
};

export default borderIcons;
